import React from "react";
import Popup from './Popup.js';
import ErrorBoundary from './ErrorBoundary.js';
import Dropdown from 'react-dropdown'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import Table from 'react-expandable-table';
import TableScrollbar from 'react-table-scrollbar';
import NotePopup from "./NotePopup.js";
import db from './db.js';
import HubPopup from "./HubPopup.js";
import MoveHubPopup from './MoveHubPopup.js';
import ThirdPartyWebHookTable from "./ThirdPartyWebHookTable.js"
import SearchPopupButton from './SearchPopupButton';
import DeviceTable from "./DeviceTable"
import HubSpotContactTable from "./HubspotContactTable.js";
import OrderAllTable from "./OrderAllTable.js";
import ExecuteScriptPopupButton from "./ExecuteScriptPopupButton"
var tableColumnRender = require("./TableColumnRender.js")
var functions = require("./functions.js");
import Select from 'react-select';
const newRecordId=-1;
const facilityTabDataHeight="80vh";
const hubSpotContactsChildTab=1;
const hubSpotContactsParentTab=2;
const facilityTypeList = [
    { value: 'commercial', label: 'commercial' },
    { value: 'wave', label: 'wave' },
    { value: 'Loaner', label: 'Loaner' },
    { value: 'Demo', label: 'Demo' },
    { value: 'Loaner/Gift?', label: 'Loaner/Gift?' },
    { value: 'consumer', label: 'consumer' }
];

// FacilityPopup Component
export default class FacilityPopup extends React.Component {

    static emptyFacility={id:-1, notes:[], hubs:[]};
    static inventoryFacilityId=1;
    static retiredFacilityId=2;
    static needToBeFixedFacilityId=3;
    static boardInventoryFacilityId=12;

    // initlize the Facility popup
    constructor(props) {
        super(props);

 

        this.state={
            facility : Object.assign({}, FacilityPopup.emptyFacility) 
            ,postFacilityModified : false
            ,postFacility : Object.assign({}, FacilityPopup.emptyFacility) 
            //, facilityVisible:false
            ,hub:Object.assign({}, FacilityPopup.emptyFacility)
            ,hubVisible:false

            , facilityNote:Object.assign({}, NotePopup.emptyNote)
            , facilityNoteVisible:false            
            , notesDisplay:[]
            ,moveHubVisible:false
            ,facilityHubSpotTab:0
            ,otherCompanyId:""
        };
        this.hubspotRefChild = React.createRef();
        this.hubspotRefParent = React.createRef();        

    }     
    componentDidUpdate(prevProps) {
    }    
    // load the table
    loadData(){
        if(this.props.visible){
            db.getFacility( 
                this.props.facilityId
                ,this.props.securityObject
                ,(facility) => { 

                    this.setState({
                        facility : facility
                        , defaultFacilityTypeOption : facilityTypeList.find(option => option.value === facility.facility_type)
                    })
                    this.updateNoteTypeInputValue();
                }
            )
        }
    }
    // render
    render() {
     
        if(!this.state.facility){
            this.loadData();
        } else  if(this.props.facilityId!==this.state.facility.id){
            this.loadData();
        }
        let facilityHubSpotTab=0;
        //if(!this.props.hubspot_company_id){
        //    facilityHubSpotTab=1;
        //}
        if(!this.state.facility){
            this.setState({
                postFacilityModified:false
                ,postFacility : Object.assign({}, FacilityPopup.emptyFacility) 
                ,facility : Object.assign({}, FacilityPopup.emptyFacility) 
                ,facilityHubSpotTab:facilityHubSpotTab
            })
        }
        return(this.props.visible && this.state.facility) ? (
            <Popup className="facility-popup" trigger={ this.props.visible}  >
            <h3>
                { this.state.facility.id} - { this.state.facility.display_name} 
                ({  this.state.facility.source})
                { functions.showModified(this.state.postFacilityModified) }
            </h3>
            <div className="align-right">                   
                <button className="" onClick={() => this.closeFacilityPopup() }>x</button>
            </div>
            <Tabs defaultIndex={this.props.tabIndex} onSelect={(index)=>{
                        if(index===hubSpotContactsChildTab){
                            functions.sleep(1000).then(() => {
                                if(this.hubspotRefChild.current){
                                    this.hubspotRefChild.current.queryData();
                                }
                            });
                        }
                        if(index===hubSpotContactsParentTab){
                            if(this.state.facility.hubspot_parent_company_id){
                                functions.sleep(1000).then(() => {
                                    if(this.hubspotRefParent.current){
                                        this.hubspotRefParent.current.queryData();
                                    }
                                });
                            }
                        }
//                            functions.sleep(1000).then(() => {
                                //let inputObj=document.getElementById("searchTableInputsearch_column");
                                //if(index===1){
                                //    this.hubspotRefChild.current.queryData();
                                //}
                                //if(index===2){
                                //    this.hubspotRefParent.current.queryData();
                                }
//                                if(inputObj){
//                                    inputObj.value=this.state.facility.hubspot_search;
//                                    if(this.state.facility && this.state.facility.hubspot_search && this.state.facility.hubspot_search!==""){
//                                        this.hubspotRefChild.current.queryData();
//                                    }
//                                }                    
//                            });
//                        }
//                    }
                }>
                <TabList>
                    <Tab >HubSpot/Facility</Tab>
                    <Tab disabled={this.state.postFacilityModified || this.state.facility.id===newRecordId}>HubSpot Contacts</Tab>
                    <Tab disabled={this.state.postFacilityModified || this.state.facility.id===newRecordId || !this.state.facility.hubspot_parent_company_id }>HubSpot Contacts(Parent)</Tab>
                    <Tab disabled={this.state.postFacilityModified || this.state.facility.id===newRecordId}>Notes</Tab>
                    <Tab disabled={this.state.postFacilityModified || this.state.facility.id===newRecordId}>Hubs</Tab>
                    <Tab disabled={this.state.postFacilityModified || this.state.facility.id===newRecordId}>Devices</Tab>
                    <Tab disabled={this.state.postFacilityModified || this.state.facility.id===newRecordId}>Third Party Web Hooks</Tab>
                    <Tab disabled={this.state.postFacilityModified || this.state.facility.id===newRecordId}>Orders</Tab>
                </TabList>                    
                <TabPanel>
                    <div style={{height:facilityTabDataHeight}}>
                        <ErrorBoundary>
                            <h3>
                                { this.state.errorMessage}
                            </h3>

                            <Tabs defaultIndex={facilityHubSpotTab}>
                                <TabList>
                                    <Tab>HubSpot</Tab>
                                    <Tab>Facility(depricated)</Tab>
                                </TabList>
                                <TabPanel>
                                    <fieldset>
                                        <legend >HubSpot/Katana</legend>
                                        <div className="float-left">
                                            <fieldset>
                                                    <legend >Select</legend>
                                                    <input type="text" className="input_zip" id="inp_hubspot_company_id" defaultValue={ this.state.facility.hubspot_company_id} disabled/><br />
                                                    <input type="text" className="input_city" id="inp_hubspot_company_name" defaultValue={ this.state.facility.hubspot_company_name } disabled /><br />
                                                    <input type="text" className="input_city" id="inp_hubspot_company_domain" defaultValue={ this.state.facility.hubspot_company_domain } disabled /><br />
                                                    <SearchPopupButton
                                                        securityObject={this.props.securityObject}
                                                        buttonLabel="Select HubSpot Company"
                                                        query={this.props.securityObject.httpServer + "api/get/hubSpotCompany?"}
                                                        columns={[
                                                                { key: 'hubspot_object_id', title:"Hubspot Object Id", width :20, noquery:true }
                                                                ,{ key: 'name', title:"HubSpot Name", width :40, noquery:true }
                                                                ,{ key: 'address', title:"address", width:40, noquery:true}
                                                                ,{ key: 'city', title:"city", width :40, noquery:true }
                                                                ,{ key: 'state', title:"state", width :40, noquery:true }
                                                                ,{ key: 'facility_name', title:"Facility Name", width :40, noquery:true }
                                                                ,{ key:'facility_id', title:"Facility_id", width:10, noquery:true}
                                                                ,{ key:'search_column', title:"search_column", width:10}
                                                                ]}
                                                        onClick={this.selectHubSpotCompany.bind(this)}
                                                    >
                                                    </SearchPopupButton>

                                            </fieldset>
                                        </div>

                                        <div className="float-left">
                                            <fieldset>
                                                    <legend >
                                                        <button onClick={()=>functions.openHubspotCompany(this.state.facility.hubspot_company_id )}>HubSpot</button>&nbsp;
                                                        Company&nbsp;
                                                        &nbsp; {this.state.facility.hubspot_company_id}
                                                        &nbsp;
                                                    <ExecuteScriptPopupButton
                                                            disabled={this.state.postFacilityModified}
                                                            securityObject={this.props.securityObject}
                                                            buttonLabel="Refresh"
                                                            screenLabel="Refresh data in Device App with latest data from HubSpot"
                                                            onClose={()=>this.loadData(true)}
                                                            url={`api/processUpdateHubSpotCompany?hubspot_company_id=${this.state.facility.hubspot_company_id}&user=${this.state.hub.processor_user}`}
                                                        >
                                                    </ExecuteScriptPopupButton>
                                                    </legend>
                                                    <label className="short-label">
                                                        Name
                                                    </label>
                                                    { this.state.facility.hubspot_company_name}
                            
                                                    <br />
                                                    <fieldset>
                                                        <legend >Contact</legend>
                                                        <label>Address</label><br />
                                                        { this.state.facility.hubspot_company_address}<br />
                                                        { this.state.facility.hubspot_company_address2}<br />
                                                        { this.state.facility.hubspot_company_city},&nbsp; 
                                                        { this.state.facility.hubspot_company_state}&nbsp;
                                                        { this.state.facility.hubspot_company_zip} &nbsp;
                                                        { this.state.facility.hubspot_company_country}<br />
                                                        <label className="short-label">phone</label>{ this.state.facility.hubspot_company_phone}<br />
                                                        <label className="short-label">profile</label>{ this.state.facility.company_profile}<br />
                                                    </fieldset>
                                                    Refresh other Hubspot Company 
                                                    <input id="otherCompanyId" size="10" style={{width: '50px'}} onChange={()=>this.setOtherCompanyId()}
                                                    ></input>
                                                    <ExecuteScriptPopupButton
                                                            disabled={this.state.postFacilityModified}
                                                            securityObject={this.props.securityObject}
                                                            buttonLabel="Refresh"
                                                            screenLabel="Refresh data in Device App with latest data from HubSpot"
                                                            onClose={()=>this.loadData(true)}
                                                            url={`api/processUpdateHubSpotCompany?hubspot_company_id=${this.state.otherCompanyId}&user=${this.state.hub.processor_user}`}
                                                        >
                                                    </ExecuteScriptPopupButton>
                                            </fieldset>
                                        </div>
                                        <div className="float-left">
                                            <fieldset>
                                                <legend >
                                                    <button onClick={()=>functions.openHubspotCompany(this.state.facility.hubspot_parent_company_id )}>HubSpot</button>
                                                    &nbsp; Parent Company&nbsp;
                                                    &nbsp; {this.state.facility.hubspot_parent_company_id}
                                                    &nbsp;
                                                    <ExecuteScriptPopupButton
                                                            disabled={this.state.postFacilityModified}
                                                            securityObject={this.props.securityObject}
                                                            buttonLabel="Refresh"
                                                            screenLabel="Refresh data in Device App with latest data from HubSpot"
                                                            onClose={()=>this.loadData(true)}
                                                            url={`api/processUpdateHubSpotCompany?hubspot_company_id=${this.state.facility.hubspot_parent_company_id}&user=${this.state.hub.processor_user}`}
                                                        >
                                                    </ExecuteScriptPopupButton>
                                                </legend>
                                                <label className="short-label">Name</label>{ this.state.facility.hubspot_parent_company_name}<br />
                                                <fieldset>
                                                    <legend >Contact</legend>                                                
                                                    <label>Address</label><br />
                                                    { this.state.facility.hubspot_parent_company_address}<br />
                                                    { this.state.facility.hubspot_parent_company_address2}<br />
                                                    { this.state.facility.hubspot_parent_company_city},&nbsp; 
                                                    { this.state.facility.hubspot_parent_company_state}&nbsp;
                                                    { this.state.facility.hubspot_parent_company_zip} &nbsp;
                                                    { this.state.facility.hubspot_parent_company_country}<br />
                                                </fieldset>
                                            </fieldset>
                                        </div>
                                        <div className="float-left">
                                            <fieldset>
                                                <legend >
                                                    <button onClick={()=>this.openKatanaCompany(this.state.facility.katana_customer_id )}>Katana</button>&nbsp;
                                                    Company
                                                </legend>
                                                <label className="short-label">Katana Customer No.</label>
                                                <input className="input_zip" type="text" name="katana_customer_id" id="inp_katana_customer_id" defaultValue={ this.state.facility.katana_customer_id} onChange={this.updateFacilityInputValue.bind(this)}/>
                                                <SearchPopupButton
                                                        securityObject={this.props.securityObject}
                                                        buttonLabel="Select Katana Customer"
                                                        query={this.props.securityObject.httpServer + "api/get/katanaCustomer?"}
                                                        columns={[
                                                                //{ key: 'customer_id', title:"Customer ID", width :20 }
                                                                { key: 'name', title:"Name", width :40 }
                                                                ,{ key: 'company', title:"company", width :40 }
                                                                ,{ key:'sales_count', title:'Katana Sales Count', width :20}
                                                                ,{ key:'comment', title:'Comment', width :20}
                                                                ]}
                                                        onClick={this.selectKatanaCustomer.bind(this)}
                                                ></SearchPopupButton><br />
                                                <br />
                                                <button onClick={()=>this.createKatanaCustomer()}>
                                                    Create Katana Customer
                                                </button>
                                                <label className="short-label">Name</label>
                                                <input className="input_city" type="text" name="katana_name" id="inp_katana_name" defaultValue={ this.state.facility.katana_name}/>
                                                <br />
                                                <label className="short-label">Company</label>
                                                <input className="input_city" type="text" name="katana_company" id="inp_katana_company" defaultValue={ this.state.facility.katana_company}/>

                                             </fieldset>
                                        </div>
                                    </fieldset>
                                </TabPanel>
                                <TabPanel>
                                    <fieldset>
                                        <legend >Facility</legend>
                                        <label>ID</label>

                                        <input type="text" disabled name="id" id="id" defaultValue={ this.state.facility.id}  />
                                        <br />

                                        <label>Facility Name</label>
                                        <input autoFocus type="text" id="facility_name" name="facility_name" 
                                            defaultValue={ this.state.facility.facility_name}  
                                            onChange={this.updateFacilityInputValue.bind(this)}
                                        />
                                        <br />
                                        DO NOT CHANGE FACILITY NAME UNLESS THE ENTITY HAS LEGALY CHANGED THEIR NAME
                                        <br />
                                        <label>Organization</label>
                                        <input type="text" className="input_zip" id="inp_organization_id" defaultValue={ this.state.facility.organization_id } disabled/>
                                        <input type="text" className="input_city" id="inp_organization_name" defaultValue={ this.state.facility.organization_name } disabled />
                                        <input type="text" className="input_city" id="inp_organization_type" defaultValue={ this.state.facility.organization_type } disabled />
                                        <SearchPopupButton
                                            securityObject={this.props.securityObject}
                                            buttonLabel="Select Organization"
                                            query={this.props.securityObject.httpServer + "api/get/organization?"}
                                            columns={[
                                                    //{ key: 'id', title:"organization id", width :20 }
                                                    { key: 'organization_name', title:"organization name", width :40 }
                                                    ,{ key: 'organization_type', title:"organization type", width :40 }
                                                    ]}
                                            onClick={this.selectOrganization.bind(this)}
                                        >
                                        </SearchPopupButton>
                                        <button onClick={this.clearOrganization.bind(this)}>
                                            Clear Organization
                                        </button>
                                        <label>Facility Address</label>
                                        <textarea className="AddressTextArea" name="facility_address" defaultValue={ this.state.facility.facility_address } onChange={this.updateFacilityInputValue.bind(this)} />&nbsp;
                                        <br />
                                        <label>City</label>
                                        <input type="text" className="input_city" maxLength="50" name="facility_city" defaultValue={ this.state.facility.facility_city } onChange={this.updateFacilityInputValue.bind(this)}/>
                                        <span>State</span>
                                        <input type="text" className="input_state" maxLength="2" size="2" name="facility_state" defaultValue={ this.state.facility.facility_state } onChange={this.updateFacilityInputValue.bind(this)}/>
                                        <span>Zip</span>
                                        <input type="text" className="input_zip" maxLength="10" size="10" name="facility_zip" defaultValue={ this.state.facility.facility_zip } onChange={this.updateFacilityInputValue.bind(this)}/>
                                        <span>Country</span>
                                        <input type="text" className="input_country" maxLength="50" name="facility_country" defaultValue={ this.state.facility.facility_country } onChange={this.updateFacilityInputValue.bind(this)}/>
                                        <br />

                                        <label>Contact Name</label>
                                        <input type="text" name="contact_name" defaultValue={ this.state.facility.contact_name } onChange={this.updateFacilityInputValue.bind(this)}/>
                                        <br />

                                        <label>Contact Phone</label>
                                        <input type="text" name="contact_phone" defaultValue={ this.state.facility.contact_phone } onChange={this.updateFacilityInputValue.bind(this)}/>
                                        <br />

                                        <label>Contact Email</label>
                                        <input type="text" name="contact_email" defaultValue={ this.state.facility.contact_email} onChange={this.updateFacilityInputValue.bind(this)}/>
                                        <br />
                                        <label>Shipping Labels</label>
                                        <br></br>
                                        <Dropdown
                                            id="label_type" 
                                            value={JSON.parse(this.props.securityObject.systemSettings.shipping_labels )[0].value}
                                            onChange={()=>this.updateLabelType.bind(this)}
                                            options={JSON.parse(this.props.securityObject.systemSettings.shipping_labels )} 
                                            placeholder="Select Label Type" 
                                        />  
                                        <button onClick={this.downloadCSV.bind(this)}>Download csv</button>  
                                        <br></br>                         
                                        <a target="new" href="https://reg.usps.com/entreg/LoginAction_input">usps</a> &nbsp;
                                        <a target="new" href="https://www.ups.com/lasso/login">ups</a>&nbsp;
                                        <a target="new" href="https://mydhl.express.dhl/us/en/home.html#/createNewShipmentTab">DHL</a>&nbsp;
                                        <a target="new" href="https://apps.goshippo.com/">shippo</a>&nbsp;
                                        <a target="new" href="https://www.wavedds.com/">wavedds.com (WIX)</a>&nbsp;
                                        <a target="new" href="https://katanamrp.com/login/">katana</a>&nbsp;
                                        <a target="new" href="https://manage.wix.com/dashboard/0cab24b4-fe4e-43e4-ae63-931c4a84e814/store/orders/?referralInfo=sidebar&view=AllOrders">WIX Orders</a>&nbsp;
                                        <a target="new" href="https://app.hubspot.com/login/">HubSpot</a>&nbsp;
                                        <a target="new" href="https://docs.google.com/document/d/1td85DZglLQ-b1mxXEIeRMca_NzY-Id2La2IkMLbki6Q/edit">Assembly instructions</a>&nbsp;
                                        <a target="new" href="https://www.google.com/url?q=https%3A%2F%2Fdashboard.wavedds.net%2Fd%2Fy5JUz7cGz%2Fall-hubs-summary%3ForgId%3D1%26refresh%3D5m&sa=D&sntz=1&usg=AOvVaw1B4jrcCQyxT7egcbkeGXr3">Grafana</a>&nbsp;
                                        <a target="new" href="https://app.slack.com/">Slack</a>&nbsp;
                                        <a target="new" href="https://github.com/">GitHub</a>&nbsp;
                                        <a target="new" href="https://github.com/issues/assigned">GitHub Issues</a>&nbsp;
                                        <a target="new" href="https://docs.google.com/spreadsheets/d/1U2EYn4BM3bIUA5_O6mhMVAbkiUh10lzCiui3U3PIuFE/edit#gid=632309989">Beacon Ordering Requirements</a>&nbsp;
                                        <a target="new" href="https://sites.google.com/wavedds.com/internal/home">Wave QuickLook</a>&nbsp;

                                    </fieldset>
                                </TabPanel>
                            </Tabs>
                            <fieldset>
                                <legend >facility</legend>
                                <br />

                                <label>Facility Type</label>
                                <Select id="selectFacilityType" 
                                    onChange={this.updateFacilityTypeInputValue.bind(this)} 
                                    value={this.state.defaultFacilityTypeOption}
                                    options={facilityTypeList}
                                    >
                                </Select>                                                   
                                <br />
                                <label>WIX Order Number</label>
                                <input type="text" name="wix_order_number" defaultValue={ this.state.facility.wix_order_number} onChange={this.updateFacilityInputValue.bind(this)}/>
                                <br />

                                <label>Facility Major</label>
                                <input type="text" name="major" defaultValue={ this.state.facility.major } onChange={this.updateFacilityInputValue.bind(this)} />
                                <br />

                                <label>Facility Note</label>
                                <textarea className="CustometNoteTextArea" name="facility_note" defaultValue={ this.state.facility.facility_note } onChange={this.updateFacilityInputValue.bind(this)} />
                                <br />

                            </fieldset>

                            <button disabled={!this.state.postFacilityModified} className="" onClick={() => this.closeFacilityPopup() }>Close</button>
                            <button disabled={!this.state.postFacilityModified} className="" onClick={() => this.saveFacility(this)  }>Save</button>

                        </ErrorBoundary>
                    </div>
                </TabPanel>
                <TabPanel>
                    <HubSpotContactTable
                        securityObject={this.props.securityObject}
                        facilityId={this.state.facility.id}
                        hubspotCompanyId={this.state.facility.hubspot_company_id}
                        ref={this.hubspotRefChild}
                    >

                    </HubSpotContactTable>
                </TabPanel>
                <TabPanel>
                    <HubSpotContactTable
                        securityObject={this.props.securityObject}
                        facilityId={this.state.facility.id}
                        hubspotCompanyId={this.state.facility.hubspot_parent_company_id}
                        ref={this.hubspotRefParent}
                    >

                    </HubSpotContactTable>
                </TabPanel>
                <TabPanel>
                    <button onClick={() => this.addFacilityNote(this)}>+</button>
                    <Dropdown
                        name="note_type" 
                        options={JSON.parse(this.props.securityObject.systemSettings.note_type_list )} 
                        onChange={()=>this.updateNoteTypeInputValue.bind(this)} 
                        placeholder="Filter by Type" 
                    />   
                    <TableScrollbar height={facilityTabDataHeight} >
                        <ErrorBoundary>
                            <Table key="facilityPopupTable" columns={[
                                    //{ title: 'Date', key: 'notedate', width :15, render:NotePopup.renderDateNoteDate }
                                    //,{ title:'Type', key: 'note_type', width :15 }
                                    { title:'Note', key: 'note', width :70, render:tableColumnRender.renderNoteWithPossibleLink }
                                    ]} 
                                    dataSource={this.state.notesDisplay} 
                                    onRowClick={this.editFacilityNote.bind(this)}
                            />
                        </ErrorBoundary>
                    </TableScrollbar>
                </TabPanel>
                <TabPanel>
                    <button disabled={this.state.facility.id===this.inventoryFacilityId} 
                        onClick={() => this.moveHub()}>
                        Move Hub From Inventory
                    </button>
                    <TableScrollbar  height={facilityTabDataHeight}>
                        <ErrorBoundary>
                            <Table columns={[
                                        { key: 'id', title:"ID", width :10 } 
                                        , { key: 'hostname', title:"Host Name", width :20 }
                                        , { key: 'display_name', title:"Name", width :20 }
                                        , { key: 'status', title:"Status", width :10 }
                                        , { key: 'update_at', title:"Last Update", width :10, render: this.renderDateUpdateAt }
                                        , { key: 'facility_city', title:"City", width :10 }
                                        , { key: 'facility_state', title:"State", width :10 }
                                    ]} 
                                    dataSource={this.state.facility.hubs} 
                                    onRowClick={this.editHub.bind(this)} 
                                    />
                        </ErrorBoundary>
                    </TableScrollbar>                        
                </TabPanel>
                <TabPanel>
                    <DeviceTable 
                        securityObject={this.props.securityObject}
                        facilityId={this.props.facilityId}
                        facilityName={this.state.facility.facility_name}
                    ></DeviceTable>                                
                </TabPanel>
                <TabPanel>
                    <ThirdPartyWebHookTable 
                        securityObject={this.props.securityObject}
                        facility_id={this.props.facilityId}
                    ></ThirdPartyWebHookTable>
                </TabPanel>                  
                <TabPanel>
                    <OrderAllTable
                        securityObject={this.props.securityObject}
                        facility_id={this.props.facilityId}
                        >
                    </OrderAllTable>
                </TabPanel>

            </Tabs>
            <HubPopup
                hubId={this.state.hub.id}
                visible={this.state.hubVisible}
                securityObject={this.props.securityObject}
                onCloseHubPopup={this.closeHubPopup.bind(this)}
            >
            </HubPopup>
            <NotePopup
                tableName="facility_note"
                filterLoc="c"
                note={this.state.facilityNote}
                facility={this.state.facility}
                hub={this.state.hub}
                visible={this.state.facilityNoteVisible}
                securityObject={this.props.securityObject}
                onCloseNotePopup={this.closeNotePopup.bind(this)}
            ></NotePopup>
            <MoveHubPopup
                facility={this.state.facility}
                visible={this.state.moveHubVisible}
                securityObject={this.props.securityObject}
                onCloseMoveHubPopup={this.closeMoveHubPopup.bind(this)}
            >
            </MoveHubPopup>            
        </Popup>                
        ) :"";
    }
    // edit a hub
    editHub( rowData, rowIndex ){
        this.setState({
            hub:rowData
            , hubVisible:true
        })
    }
    // close this popup
    closeFacilityPopup(){
        if(this.state.postFacilityModified){
            if (window.confirm("The screen has been modifies.  Would you like to exit without saving changes?") === true) {
                this.close();
            } 
        } else {
            this.close();
        }
    }
    // close
    close(){
        this.setState({
            postFacilityModified:false
            ,postFacility : Object.assign({}, FacilityPopup.emptyFacility) 
            ,facility : Object.assign({}, FacilityPopup.emptyFacility) 
        })
        this.props.onCloseFacilityPopup();
    }

    // update the postFacility object with values that were edited on screen
    updateFacilityInputValue(evt){
        let postFacility=this.state.postFacility;
        postFacility[evt.currentTarget.name] = evt.currentTarget.value;         
        this.setState({
            postFacilityModified:true,
            postFacility: postFacility
        });        
    }
    // update facility_type in postFacility object with values that were edited on screen
    updateFacilityTypeInputValue(option){
        let postFacility=this.state.postFacility;
        postFacility.facility_type = option.value;
        this.setState({
            postFacilityModified:true
            , postFacility : postFacility
            , defaultFacilityTypeOption : option
        });        
    }
    renderDateUpdateAt(cellData, rowData, rowIndex){
        return functions.reactDate(rowData.updated_at);
    }
    // update label_type
    updateLabelType(option){
        this.setState({
            label_type:option.value
        });        
    }

    // save the facility
    saveFacility(thisApp){

        // id modifying facility set the id
        let postFacility=thisApp.state.postFacility;
        if(thisApp.props.facilityId!==newRecordId){
            postFacility.id=thisApp.props.facilityId;
        } else {
            if(this.props.organization){
                postFacility.organization_id=this.props.organization.id
            }
            postFacility.facility_type = document.getElementById("selectFacilityType").value;
        }
        thisApp.state.postFacility.last_updated_by=this.props.securityObject.userName;
        thisApp.setState({
            postFacility:postFacility
        })            
        // save the data
        db.saveData( thisApp.props.securityObject
            , thisApp.state.postFacility
            ,"api/updateFacility"
            , function(result){
                thisApp.loadData();
                thisApp.setState({
                    postFacilityModified:false
                }); 
                if(thisApp.props.facilityId===-1){
                    thisApp.close();
                }
            });
    }
   
    // close the hub popup
    closeHubPopup(){
        this.loadData();
        this.setState({
            hubVisible:false           
        })
    }
    // close the move hub popup
    closeMoveHubPopup(){
        this.loadData();
        this.setState({
            moveHubVisible:false           
        })
    }
    // show move hub popup
    moveHub(){
        this.setState({
            moveHubVisible:true
        })
    }
    // close the note popup
    closeNotePopup(){
        this.loadData();
        this.setState({
            facilityNoteVisible:false           
        })

    }
    // edit the facilitys note
    editFacilityNote( rowData, rowIndex ){
        this.setState({
            facilityNote:rowData
            , facilityNoteVisible:true
        })
    }
    // add a facility note
    addFacilityNote(thisApp){
        let note = Object.assign({}, NotePopup.emptyNote);
        note.facility_id=thisApp.props.facilityId;
        thisApp.setState({
            facilityNote:note
            , facilityNoteVisible:true
        })
    }
        

    // filter notes
    updateNoteTypeInputValue(option) {
        let notesDisplay=[];
        this.state.facility.notes.forEach(note=>{
            if(!option){
                notesDisplay.push(note);
            } else if(note.note_type===option.value){
                notesDisplay.push(note);
            }
        })
        this.setState({
            notesDisplay : notesDisplay
        })

    }

    downloadCSV(){
        let facility={};
        Object.keys(this.state.facility).map((key) => facility[key]=blankIfNull(this.state.facility[key]));
        let addrArr=facility.facility_address.split("\n");
        facility.address1=blankIfNull(addrArr[0]);
        facility.address2="";
        if(addrArr.length>2){
            facility.address2=blankIfNull(addrArr[1]);
        }
        //let csz=addrArr[addrArr.length-1].trim();
        //let cszArr=csz.split(" ");
        facility.city=facility.facility_city;
        facility.state=facility.facility_state;
        facility.zip=facility.facility_zip;
        console.log(this.state.label_type);
        let labels=JSON.parse(this.props.securityObject.systemSettings.shipping_labels );
        console.log(labels[0].label);
        let pos=0;
        let cnt=0;
        labels.forEach(label=>{
            if(label.value===this.state.label_type){
                pos=cnt;
            }
            cnt++
        })
        let label=labels[pos];
        let cmd="`"+label.HeaderLine + "\n" + label.DataLine+"\n"+"`";
        let out=eval(cmd);
        console.log(out);
        var input = document.createElement('a');
        input.href = 'data:attachment/csv;charset=utf-8,' + encodeURI(out);
        input.target = '_blank';
        input.download= facility.id+
                    "-"+
                    facility.wix_order_number+
                    "-"+
                    facility.facility_name+
                    '.csv';
        document.body.appendChild(input);
        input.click();
        document.body.removeChild(input);                

        function blankIfNull(val){
            if(val==null){
                return "";
            }
            if(val===undefined){
                return "";
            }
            return val;
        }

    }
    clearOrganization(){
        this.selectOrganization(    
            {
                id:"",
                organization_name:"",
                organization_type:""
            });
    }
    selectOrganization(rowData){
        document.getElementById("inp_organization_id").value=rowData.id;
        document.getElementById("inp_organization_name").value=rowData.organization_name;
        document.getElementById("inp_organization_type").value=rowData.organization_type;
        let postFacility=this.state.postFacility;
        postFacility.organization_id = rowData.id;         
        this.setState({
            postFacilityModified:true,
            postFacility: postFacility
        });           
    }    
    selectHubSpotCompany(rowData){
        if(rowData.facility_name){
            alert("This company is already assigned to a facility ("+rowData.facility_name+")")
        } else {
            document.getElementById("inp_hubspot_company_id").value=rowData.hubspot_object_id;
            document.getElementById("inp_hubspot_company_name").value=rowData.name;
            document.getElementById("inp_hubspot_company_domain").value=rowData.domain;
            let postFacility=this.state.postFacility;
            postFacility.hubspot_company_id = rowData.hubspot_object_id;         
            this.setState({
                postFacilityModified:true,
                postFacility: postFacility
            });     
        }      
    }    
    selectKatanaCustomer(rowData){
        if(rowData.facility_name){
            alert("This company is already assigned to a facility ("+rowData.facility_name+")")
        } else {
            document.getElementById("inp_katana_customer_id").value=rowData.customer_id;
            document.getElementById("inp_katana_name").value=rowData.name;
            document.getElementById("inp_katana_company").value=rowData.company;
            let postFacility=this.state.postFacility;
            postFacility.katana_customer_id = rowData.customer_id;         
            this.setState({
                postFacilityModified:true,
                postFacility: postFacility
            });     
        }      
    }   
    createKatanaCustomer(){
        let thisApp=this;
        try {
            db.saveData( this.props.securityObject
                , {"facility_id":this.state.facility.id}
                ,"api/createKatanaCustomer"
                , function(result){
                    alert(JSON.stringify(result,2,null))
                    thisApp.loadData();
                }
                , function(error){
                    alert(JSON.stringify(error,null,2));
                }
            );
        } catch (ex){
            alert(ex);
        }
    }
    isSelected(v1,v2){
        if(v1===v2){
            return "selected";
        } else {
            return "";
        }
    }
    setOtherCompanyId(){
        if(document.getElementById("otherCompanyId")){
            this.setState({ 
                otherCompanyId: document.getElementById("otherCompanyId").value
            });
        }
    }
}

